import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1200Model } from '../kymw1200.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * サイクル設定商品表示順登録サービス
 * @export RegistCycleSortService
 * @class RegistCycleSortService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistCycleSortService extends PlessJsonResponderSub<null> {
  model: KYMW1200Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistCycleSortService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MediumType: this.model.searchedMediumType,
        PCodes: this.model.itemList.map(_ => _.pcode).join(','),
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof RegistCycleSortService
   */
  execute(model: KYMW1200Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('registCycleSort', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof RegistCycleSortService
   */
  success() {
    if (this.calbak) this.calbak();
  }
}
